module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Gc-Da-Ea.b5f5515c.png";